<template>
    <div class="anexo-grid-wrapper">
        <div v-if="titulo || anexos.length" class="anexo-grid-header">
            <h4 v-if="titulo" class="anexo-grid-title">
                {{ titulo }}
            </h4>

            <span v-if="mostrarContador" class="anexo-grid-count">
                {{ anexos.length }} {{ anexos.length === 1 ? 'anexo' : 'anexos' }}
            </span>
        </div>

        <div v-if="!anexos.length" class="anexo-grid-empty">
            Nenhum anexo localizado.
        </div>

        <div v-else class="anexo-grid">
            <AnexoCard
                v-for="anexo in anexos"
                :key="anexo.id"
                :anexo="anexo"
                :permite-remover="permiteRemover"
                @visualizar="$emit('visualizar', $event)"
                @download="$emit('download', $event)"
                @remover="$emit('remover', $event)"
            />
        </div>
    </div>
</template>

<script setup>
import AnexoCard from './AnexoCard.vue';

defineProps({
    anexos: {
        type: Array,
        default: () => [],
    },
    titulo: {
        type: String,
        default: '',
    },
    mostrarContador: {
        type: Boolean,
        default: true,
    },
    permiteRemover: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['visualizar', 'download', 'remover']);
</script>

<style scoped>
.anexo-grid-wrapper {
    width: 100%;
}

.anexo-grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
}

.anexo-grid-title {
    margin: 0;
    color: #333;
    font-size: 16px;
    font-weight: 600;
}

.anexo-grid-count {
    font-size: 12px;
    color: #666;
    background: #f3f3f3;
    border-radius: 999px;
    padding: 4px 9px;
    white-space: nowrap;
}

.anexo-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 14px;
}

.anexo-grid-empty {
    padding: 16px;
    border: 1px dashed #ccc;
    border-radius: 8px;
    color: #777;
    background: #fafafa;
    text-align: center;
}

@media (max-width: 480px) {
    .anexo-grid {
        grid-template-columns: 1fr;
    }

    .anexo-grid-header {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>
